import { SkeletonLoader } from '@/components';
import { cn } from '@/utils';
import { scoreHistoryCardStyles, scoreHistoryListStyles } from '../ScoreHistoryCard.styles';
import { ScoreHistoryCardTitle } from './ScoreHistoryCardTitle';
import React from 'react';

/**
 * Props for the ScoreHistoryCardLoader component.
 */
interface ScoreHistoryCardLoaderProps {
  /** Additional CSS classes forwarded to the outer card wrapper. */
  className?: string;
  /** Number of skeleton rows to render, matching the card's `initialVisibleCount`. */
  initialVisibleCount: number;
  /** Card title shown above the skeleton rows. */
  title: string;
  /** Whether to render a border around the card. */
  withCardBorder?: boolean;
}

/**
 * Loading state for ScoreHistoryCard.
 * Renders the card shell with a title and a set of skeleton placeholder rows.
 */
export const ScoreHistoryCardLoader: React.FC<ScoreHistoryCardLoaderProps> = ({
  className,
  initialVisibleCount,
  title,
  withCardBorder,
}) => (
  <div aria-busy="true" aria-label="Loading score history" className={cn(scoreHistoryCardStyles({ bordered: withCardBorder }), className)}>
    <ScoreHistoryCardTitle isLoading={true} title={title} />
    <div className={scoreHistoryListStyles}>
      <div className="flex w-full flex-col gap-2 py-4">
        {[...Array(initialVisibleCount)].map((_, index) => (
          <SkeletonLoader key={index} width="full" className="h-[2rem]" />
        ))}
      </div>
    </div>
  </div>
);

ScoreHistoryCardLoader.displayName = 'ScoreHistoryCardLoader';

export default ScoreHistoryCardLoader;
